// @ts-nocheck
import persistor from './persistor';

export const DEFAULT_MIN_VALIDITY_SECONDS = 60;

let authClient;
let refreshInFlight;
let refreshIntervalHandle;
let onWindowFocus;
let onVisibilityChange;

export function setAuthClient(client) {
    authClient = client;
}

export function getAuthClient() {
    return authClient;
}

export function getBearerToken() {
    return authClient?.token || persistor.getTokens().token || null;
}

function persistLatestTokens() {
    if (!authClient) return;

    persistor.setTokens({
        token: authClient.token,
        refreshToken: authClient.refreshToken,
        idToken: authClient.idToken,
    });
}

export async function ensureFreshToken(minValidity = DEFAULT_MIN_VALIDITY_SECONDS) {
    if (!authClient || !authClient.authenticated) {
        return persistor.getTokens().token || null;
    }

    if (!refreshInFlight) {
        refreshInFlight = Promise.resolve(authClient.updateToken(minValidity))
            .then(() => {
                persistLatestTokens();
                return authClient.token || null;
            })
            .finally(() => {
                refreshInFlight = null;
            });
    }

    await refreshInFlight;
    return getBearerToken();
}

export function startSessionRefreshLoop({ minValidity = DEFAULT_MIN_VALIDITY_SECONDS, intervalMs = 30000 } = {}) {
    if (typeof window === 'undefined') return () => {};

    if (refreshIntervalHandle) {
        window.clearInterval(refreshIntervalHandle);
        refreshIntervalHandle = null;
    }
    if (onWindowFocus) {
        window.removeEventListener('focus', onWindowFocus);
    }
    if (onVisibilityChange) {
        document.removeEventListener('visibilitychange', onVisibilityChange);
    }

    const refresh = () => {
        if (!authClient || !authClient.authenticated) return;

        ensureFreshToken(minValidity).catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Failed to refresh auth token', error);
        });
    };

    onWindowFocus = () => refresh();
    onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            refresh();
        }
    };

    window.addEventListener('focus', onWindowFocus);
    document.addEventListener('visibilitychange', onVisibilityChange);
    refreshIntervalHandle = window.setInterval(refresh, intervalMs);

    return () => {
        if (refreshIntervalHandle) {
            window.clearInterval(refreshIntervalHandle);
            refreshIntervalHandle = null;
        }

        if (onWindowFocus) {
            window.removeEventListener('focus', onWindowFocus);
            onWindowFocus = null;
        }

        if (onVisibilityChange) {
            document.removeEventListener('visibilitychange', onVisibilityChange);
            onVisibilityChange = null;
        }
    };
}
